export default "__VITE_ASSET__DOLm7a8c__"